import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import './Progress.css'

export default function CircularIndeterminate({size}) {
  return (
    <Box sx={{ display: 'flex','justifyContent':'center','alignItems':'center' }} className="progressBox">
      <CircularProgress size={size}/>
    </Box>
  );
}